import { IconStar } from "@/components/icon/simrnoff";
import { Marquee } from "./Marquee";
import { useCmsStore } from "@/components/AppHooks";
export function SimnoffTopMarquee() {
    const { localeData: {
        marquee
    } } = useCmsStore()!
    return <Marquee className="simnoff-top-marquee" speed={{
        desktop: 3,
        mobile: 5
    }}>
            <span style={{ color: marquee[0].textColor }}>{marquee[0].text}</span>
            <div className="svg-wrapper">
                <IconStar />
            </div>
            <span style={{ color: marquee[1].textColor }}>{marquee[1].text}</span>
            <div className="svg-wrapper">
                <IconStar />
            </div>
    </Marquee>

}
